// @ts-nocheck
import { removeDocument, RemoveRfqDetailsDocumentParameter } from "@store/Framework/Services/QuoteService";
import { createHandlerChainRunner, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type Props = {
    apiParameter: RemoveRfqDetailsDocumentParameter;
    apiResult: any;
};

type HandlerType = Handler<RemoveRfqDetailsDocumentParameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = { ...props.parameter };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await removeDocument(props.apiParameter);
};

export const DispatchCompleteRemoveDocument: HandlerType = props => {
    const { dispatch } = props;
    dispatch({
        type: "Store/Pages/RfqQuoteDetails/RemoveRfqDetailsDocument",
        removeDocument: props.parameter.documentName,
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess();
};

export const chain = [
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteRemoveDocument,
    ExecuteOnSuccessCallback,
];

const removeQuoteDetailsDocument = createHandlerChainRunner(chain, "RemoveQuoteDetailsDocument");
export default removeQuoteDetailsDocument;
